// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-container[data-v-035b36b6] {\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
